import { ActionTypes } from "../constants";

var initialState = {
  isOnboarded: true
}

export default function user(state = initialState, action) {

  switch(action.type) {
    case ActionTypes.SET_USER:
      return Object.assign({}, state, action.payload);
    case ActionTypes.SET_USER_PANLESS_HOLDINGS:
      return Object.assign({}, state, action.payload);
    case ActionTypes.SET_PAN_ONBOARDING:
      return {
        ...state,
        panOnboardingStage: action.payload.panOnboardingStage
      }
    case ActionTypes.SET_SHOW_ONBOARDING:
      return {
        ...state,
        showOnboarding: action.payload
      }
    default:
      return state;
  }
}